import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SHARED_MODULES } from '@app/shared';
import { ListBannersComponent } from '../list-banners/list-banners.component';

@Component({
  imports: [SHARED_MODULES, ListBannersComponent],
  templateUrl: './sidenav-banners.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavBannersComponent {}
